import { JSX } from 'react';
import { C44TestimonialCardProps } from './C44TestimonialCard.types';
import { GetTestimonialCardModel } from './C44TestimonialCard.service';
import { TestimonialCard } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C44TestimonialCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = GetTestimonialCardModel(props?.fields);

  return <TestimonialCard {...model} data-component={marketingRenderingName} />;
};

export default checkDatasourceForRendering<C44TestimonialCardProps>(Default);
